import { useMemo } from "react";

import { useCreateSubfolderMutation } from "@/graphql/folders/folders.hooks";
import { normalizeFolderName } from "@/utils/normalizeFolderName";

interface IUseCreateSubfolderOptions {
  onCompleted?: () => void;
  onError?: () => void;
}

interface IUseCreateSubfolderVariables {
  parentId: number;
  name: string;
}

const useCreateSubfolder = ({
  onCompleted,
  onError,
}: IUseCreateSubfolderOptions) => {
  const [createSubfolder, { loading, error }] = useCreateSubfolderMutation({
    context: { errorType: "local" },
    onCompleted,
    onError,
  });

  return useMemo(
    () => ({
      createSubfolder: async ({
        parentId,
        name,
      }: IUseCreateSubfolderVariables) => {
        await createSubfolder({
          variables: {
            input: { parentId, name: normalizeFolderName(name) },
          },
        });
      },
      loading,
      error,
    }),
    [createSubfolder, error, loading]
  );
};

export default useCreateSubfolder;
